import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

export default class extends Controller {
  static targets = ['copiedTooltipEl']
  static values = { copyString: String }

  copyValue(_event) {
    this.element.dataset.copied = ''

    // Hide hover tooltip
    this.element._tippy?.hide()

    // Show temporary "Copied!" tooltip
    if (this.hasCopiedTooltipElTarget && !this.copiedTippy) {
      this.copiedTippy = tippy(this.copiedTooltipElTarget, {
        animation: 'shift-away',
        content: document.body.dataset.copiedText,
        duration: [300, 300],
        hideOnClick: false,
        placement: 'top',
        trigger: 'manual',
        onHidden: (instance) => instance.destroy()
      })

      this.copiedTippy.show()
    }

    // Reset the timer if the element has been copied multiple times in quick succession
    if (this.element.copiedTimer) clearTimeout(this.element.copiedTimer)

    // Set a timer to hide the "Copied!" tooltip
    const copiedTimer = setTimeout(() => {
      this.element.removeAttribute('data-copied')
      this.copiedTippy?.hide()
      this.copiedTippy = null
    }, 1200)

    // Attach the timer to the element
    this.element.copiedTimer ||= copiedTimer

    navigator.clipboard.writeText(this.copyStringValue)
  }
}
